import { initSwiper } from '@resources/js/components/initSwiper.js'

const moreOffersElement = document.querySelector('.js-more-offers')

if (moreOffersElement) {
	// ініт головного слайдеру
	const mainSliderElement = moreOffersElement.querySelector(
		'.js-more-offers-slider'
	)

	const cardsPerView = mainSliderElement.getAttribute('cards-per-view')

	const mainSliderConfig = {
		slidesPerView: 1.1,
		loop: false,
		spaceBetween: '16',
		navigation: {
			nextEl: moreOffersElement.querySelector('.js-main-slider-next'),
			prevEl: moreOffersElement.querySelector('.js-main-slider-prev'),
		},
		breakpoints: {
			1024: {
				slidesPerView: cardsPerView || 3.2,
			},
		},
	}

	initSwiper(mainSliderElement, mainSliderConfig)

	// ініт слайдерів карток
	const offerCardElements = moreOffersElement.querySelectorAll('.js-offer-card')

	offerCardElements.forEach(cardEl => {
		const offerSliderElement = cardEl.querySelector('.js-item-slider')

		if (!offerSliderElement) return

		const offerSliderConfig = {
			navigation: {
				nextEl: cardEl.querySelector('.js-item-slider-next'),
				prevEl: cardEl.querySelector('.js-item-slider-prev'),
			},
			pagination: {
				el: cardEl.querySelector('.swiper-pagination'),
				type: 'bullets',
				dynamicBullets: true,
			},
		}

		initSwiper(offerSliderElement, offerSliderConfig)
	})
}
